import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { propFirms } from '../data/strategy';
export function PropFirmBanner() {
  return <section aria-labelledby="prop-firm-title" className="border-b border-line" data-id="element-59" data-mp="ch9rgp7zly28">
      <div className="mx-auto grid w-full max-w-[1400px] gap-10 px-6 py-14 lg:grid-cols-12 lg:items-center lg:px-10" data-id="element-60" data-mp="3txhychu53etn">
        <div className="lg:col-span-5" data-id="element-61" data-mp="2q5h62t9b1dq">
          <div className="flex items-center gap-2" data-id="element-62" data-mp="3kxuulpdxtwxf">
            <ShieldCheckIcon className="h-4 w-4 text-gold-vip" aria-hidden="true" data-id="element-63" data-mp="3kw1qohuplqt4" />
            <span id="prop-firm-title" className="font-mono text-[11px] uppercase tracking-[0.22em] text-gold-vip" data-id="element-64" data-mp="3owvcn5olcvjd">
              Prop Firm Ready
            </span>
          </div>
          <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-white/60" data-id="element-65" data-mp="198bt8y8xnb3w">
            Estrategia optimizada para superar evaluaciones de fondeo gracias al
            control estricto de Drawdown.
          </p>
        </div>

        <ul className="grid grid-cols-1 gap-px bg-line sm:grid-cols-3 lg:col-span-7" data-id="element-66" data-mp="1ako09tcq4nhk">
          {propFirms.map(firm => <li key={firm.name} className="bg-ink px-6 py-5 text-center" data-id="element-67" data-mp="15mcq1hiioayt">
              <span className="block text-[17px] font-semibold tracking-tight text-white/85" data-id="element-68" data-mp="1jcpw1ebulfli">
                {firm.name}
              </span>
              <span className="mt-1 block font-mono text-[11px] tracking-tight text-white/35" data-id="element-69" data-mp="1fes80ettczjp">
                {firm.note}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}